import { getQueryStringParameter } from '../../../helpers';
import { setupSubjectToLawsRegulationsOrInstructionsFields } from '../commitments_step';

$(() => {
  const $form = $('form#legal-profile-form');

  if ($form.length === 0 || getQueryStringParameter('id') !== 'commitments') {
    return;
  }

  setupSubjectToLawsRegulationsOrInstructionsFields($form);
});
